import { createSlice } from '@reduxjs/toolkit';
import { resetAllSlices } from '../Providers/mainStore.slice';
import { fetchUserData } from './user.thunks';

const initialState = {
  user: null,
  onboardingCompleted: null,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserState: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetAllSlices, () => {
        return initialState;
      })
      .addCase(fetchUserData.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.user = null;
        state.twoFactorOnboardingPending = false;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUserState } = userSlice.actions;
export default userSlice.reducer;
